import { render } from "./add-car.vue?vue&type=template&id=d0c563c0"
import script from "./add-car.vue?vue&type=script&lang=js"
export * from "./add-car.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__